// COPIED from ptc-core web/src/components/links/useEntityLinkProps.ts @ 822453f (fleet real links v1, 2026-10-29).
// Changes from the source: an optional router `state` (conversions' Work hands its own URL to the screen it opens, so
// Back to Work returns to the list as it was; docs/work-history.md). A plain click carries it; a new tab cannot, and
// Back to Work there falls back to the plain Work list. Conformance: realLink.test.tsx + the sweep.
import { useNavigate } from 'react-router-dom';
import { realLinkProps, type RealLinkOptions } from './realLinkProps';

/** react-router's navigate, as the real-link module's `navigate`. */
export function useRouterNavigate(state?: unknown) {
  const navigate = useNavigate();
  // programmatic-nav: the router behind a real <a href>; realLink.tsx only calls it for a plain left click.
  return (href: string) => navigate(href, state === undefined ? undefined : { state });
}

/** Props for a component that renders its own anchor: `<Button as="a" {...useEntityLinkProps('/x')}>`. */
export function useEntityLinkProps(
  href: string,
  options: Omit<RealLinkOptions, 'navigate'> & { state?: unknown } = {},
) {
  const { state, ...rest } = options;
  return realLinkProps(href, { ...rest, navigate: useRouterNavigate(state) });
}
